module.exports = __webpack_public_path__ + "img/choose-material.37249fda.png";